import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { ExternalLinkIcon } from '@assets/svgs';
import { PolicyTransactionItem } from '../types';
import { formatEffectiveDate, getTransactionTypeLabel } from '../utils/formatters';
import { currentItemStyles, externalLinkIconStyle } from '../utils/constants';

interface TransactionCardProps {
  transaction: PolicyTransactionItem;
  isCurrent: boolean;
}

export const TransactionCard = ({ transaction, isCurrent }: TransactionCardProps) => {
  const transactionLabel = getTransactionTypeLabel(transaction.transactionType);
  const effectiveDate = formatEffectiveDate(transaction.effectiveOn);
  const quoteId = transaction.quote?.id;

  const isLink = !isCurrent && !!quoteId;

  const content = (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2,
        ...currentItemStyles(isCurrent),
      }}
    >
      <Typography
        variant='body2'
        sx={{
          color: isCurrent ? 'text.primary' : quoteId ? 'secondary.main' : 'text.subdued',
          fontWeight: isCurrent ? 600 : 700,
          textDecoration: isCurrent ? 'none' : undefined,
          '&:hover': isLink ? { textDecoration: 'underline' } : undefined,
        }}
      >
        {transactionLabel} {isLink && <ExternalLinkIcon width='10px' height='10px' style={externalLinkIconStyle} />}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant='body2' color='text.secondary' fontWeight='normal'>
          {effectiveDate}
        </Typography>
      </Box>
    </Box>
  );

  if (isCurrent || !quoteId) {
    return content;
  }

  return (
    <Link
      to={`/quote/${quoteId}`}
      target='_blank'
      rel='noopener noreferrer'
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      {content}
    </Link>
  );
};
